//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { UiaProductGrid } from '@uia/products/UiaProductGrid';

export const UiaTagProducts = () => {
  return (
    <>
      {/* TODO: PD-284239 - add search bar */}
      <UiaProductGrid />
    </>
  );
};
